import React from "react";
import FlatButton from "material-ui/FlatButton";
import TextField from "material-ui/TextField";

const saveStyle = {
  position: "fixed",
  bottom: "50px",
  right: "50px",
  background: "#6da92e",
  color: "#fff"
};

const LIMIT = 100;

class TitleEditor extends React.Component {
  state = {
    value: this.props.value
  };

    static getDerivedStateFromProps(props, state) {
        return { ...state, value: props.value };
    }

  onSave = () => {
    const { onSave } = this.props;
    const { value } = this.state;
    onSave(value);
  };

  lengthChecker = str => str.length > LIMIT;
  haveError = str => str.length > LIMIT - 1;
  onChange = e => {
    const value = e.target.value;
    if (this.lengthChecker(value)) return;
    this.setState({ value });
  };

  render() {
    const { value } = this.state;
    const isError = this.haveError(value);

    return (
      <div style={{width: 'calc(100vw - 381px)', padding: "20px" }}>
        <TextField
          underlineFocusStyle={{ borderColor: "#6da92e" }}
          fullWidth
          id="text"
          type="text"
          onChange={this.onChange}
          value={value}
          placeholder="Title"
        />
        {isError && (
          <div style={{ color: "#ef5350" }}>max length 100 symbols</div>
        )}
        <FlatButton
          label="Save"
          onClick={this.onSave}
          backgroundColor="#6da92e"
          hoverColor="#7bd023"
          style={saveStyle}
        />
      </div>
    );
  }
}

export default TitleEditor;
